import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useAverageLotValueReRankingSimilarLots = () => {
    return useAmplitudeExperimentBase(
        AmplitudeExperiments.AverageLotValueReRankingSimilarLots,
        AmplitudeVariants.AverageLotValueReRankingSimilarLots.Treatment
    );
};
